import { Controller } from "@hotwired/stimulus"
import TomSelect from 'tom-select'

export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, { 
      closeAfterSelect: true,
      render: {
        no_results:function(data,escape){
          return '<div class="py-3 px-4">No results found for "'+escape(data.input)+'"</div>';
        },
      }
    })
  }

  disconnect() {
    this.select.destroy()
  }
}
